import { render } from "./sharecodeChannel.vue?vue&type=template&id=6807a586"
import script from "./sharecodeChannel.vue?vue&type=script&lang=js"
export * from "./sharecodeChannel.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/sharecodeChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6807a586"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6807a586', __exports__)) {
    console.log('reload')
    api.reload('6807a586', __exports__)
  }
  
  module.hot.accept("./sharecodeChannel.vue?vue&type=template&id=6807a586", () => {
    console.log('re-render')
    api.rerender('6807a586', render)
  })

}


export default __exports__